var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("div", { staticStyle: { position: "relative" } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          ref: "search",
          staticClass: "px-5 pl-10 py-2",
          staticStyle: { width: "100%" },
          attrs: { type: "text", placeholder: _vm.placeHolder },
          domProps: { value: _vm.query },
          on: {
            blur: function($event) {
              _vm.resultatsDeRechercheVisible = false
            },
            click: function($event) {
              _vm.resultatsDeRechercheVisible = true
            },
            focus: function($event) {
              _vm.resultatsDeRechercheVisible = true
            },
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.query = $event.target.value
              },
              _vm.softReset
            ],
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "up", 38, $event.key, [
                    "Up",
                    "ArrowUp"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.highlightPrevious.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "down", 40, $event.key, [
                    "Down",
                    "ArrowDown"
                  ])
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.highlightNext.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                $event.preventDefault()
                return _vm.pressEnterIngredient()
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape"
                  ])
                ) {
                  return null
                }
                _vm.resultatsDeRechercheVisible = false
              }
            ],
            keyup: _vm.startTimeout
          }
        }),
        _c(
          "div",
          { staticStyle: { position: "absolute", top: "7px", left: "5px" } },
          [
            _c(
              "svg",
              {
                staticClass: "h-5 w-5",
                staticStyle: { color: "grey" },
                attrs: {
                  fill: "currentColor",
                  viewBox: "0 0 24 24",
                  width: "24",
                  height: "24"
                }
              },
              [
                _c("path", {
                  staticClass: "heroicon-ui",
                  attrs: {
                    d:
                      "M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z"
                  }
                })
              ]
            )
          ]
        ),
        _vm.query.length > 0
          ? _c(
              "div",
              {
                staticStyle: {
                  position: "absolute",
                  top: "3px",
                  right: "10px",
                  color: "grey",
                  "font-size": "1.5rem"
                },
                on: { click: _vm.reset }
              },
              [
                _c("i", {
                  staticClass: "fa fa-window-close",
                  attrs: { "aria-hidden": "true" }
                })
              ]
            )
          : _vm._e()
      ]),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.query.length >= 3 && _vm.resultatsDeRechercheVisible
          ? _c(
              "div",
              {
                style:
                  "max-height:" +
                  (_vm.small ? "11" : "32") +
                  "rem;overflow:hidden;overflow-y:auto;border:1px solid #dfdfdf;background:white;"
              },
              [
                _c(
                  "div",
                  { ref: "results" },
                  [
                    _vm._l(_vm.searchResults, function(ingredient, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          class: { "bg-vert": index === _vm.highlightedIndex },
                          staticStyle: {
                            padding: ".5rem",
                            display: "flex",
                            "flex-direction": "column",
                            "text-decoration": "none",
                            color: "black",
                            cursor: "pointer"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectionIngredient(ingredient)
                            },
                            mousedown: function($event) {
                              $event.preventDefault()
                              _vm.resultatsDeRechercheVisible = true
                            },
                            mouseover: function($event) {
                              return _vm.focusOn(index)
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "line-height": "2.5rem"
                              }
                            },
                            [
                              ingredient.item.estPerso
                                ? _c("i", {
                                    staticClass: "fas fa-user push-right-1rem",
                                    staticStyle: {
                                      height: "20px",
                                      "margin-top": "10px"
                                    }
                                  })
                                : _vm._e(),
                              ingredient.item.estEtab
                                ? _c("i", {
                                    staticClass:
                                      "far fa-building push-right-1rem",
                                    staticStyle: {
                                      height: "20px",
                                      "margin-top": "10px"
                                    }
                                  })
                                : _vm._e(),
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      /*ingredient.score + " " +*/ _vm.ajouterBIO
                                        ? ingredient.item.nomBIO
                                        : ingredient.item.nom
                                    ) +
                                    " "
                                )
                              ]),
                              ingredient.item.produits
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-left": "1rem"
                                      }
                                    },
                                    _vm._l(
                                      _vm.famillesPossibles(
                                        ingredient.item.produits
                                      ),
                                      function(famille, index) {
                                        return _c("span", { key: index }, [
                                          _c("img", {
                                            staticStyle: { width: "32px" },
                                            attrs: {
                                              src:
                                                "/assets/images/icones/" +
                                                famille +
                                                "-NOIR" +
                                                ".png",
                                              alt: ""
                                            }
                                          })
                                        ])
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    }),
                    _vm.searchResults.length === 0 && _vm.query.length > 3
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "font-normal w-full border-b cursor-pointer p-4"
                          },
                          [
                            _c("p", { staticClass: "my-0" }, [
                              _vm._v("Aucun résultat pour '"),
                              _c("strong", [_vm._v(_vm._s(_vm.query))]),
                              _vm._v("'")
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }